import styled from 'styled-components'

export const TileBody = styled.div`
  padding: 5px;
  gap: 5px;
`
